require('fullcalendar/dist/fullcalendar.js');
require('fullcalendar/dist/locale-all.js');

require('esn-frontend-common-libs/src/frontend/vendor-libs.js');
require('esn-frontend-calendar/src/index.js');

require('./app/app.js');

require('./all.less');
